// Gemini AI chat service using Gemini API (text-only)
const GEMINI_API_URL = "https://generativelanguage.googleapis.com/v1beta/models/gemini-2.0-flash-lite:generateContent";
const GEMINI_API_KEY = process.env.REACT_APP_GEMINI_API_KEY;

export async function sendGeminiMessage(message, history = []) {
  if (!GEMINI_API_KEY || GEMINI_API_KEY === "null") {
    throw new Error("Gemini API key is missing. Check your .env file and restart the dev server.");
  }

  const requestBody = {
    contents: [
      ...history.map(msg => ({ role: msg.role, parts: [{ text: msg.text }] })),
      { role: "user", parts: [{ text: message }] }
    ]
  };

  const response = await fetch(`${GEMINI_API_URL}?key=${GEMINI_API_KEY}`, {
    method: "POST",
    headers: {
      "Content-Type": "application/json"
    },
    body: JSON.stringify(requestBody)
  });

  if (!response.ok) {
    throw new Error(`Gemini API error: ${response.statusText}`);
  }

  const data = await response.json();
  // Extract the AI's reply from the API response
  const aiReply = data.candidates?.[0]?.content?.parts?.[0]?.text || "No response.";
  return aiReply;
}